<template>
	<div>
		<div>
			<section class="top-fixing">
				<section class="common-sub-top container">
					<section class="top-info-wrap">
						<!-- 뒤로가가-->
						<div class="prev-wrap">
							<a class="close" @click="pageBefore()"></a>
							<div class="title">고객문의</div>
						</div>
						<!-- //뒤로가가-->
					</section>
				</section>
			</section>
			<section class="contents-wrap mt100">
				<div class="img">
					<img src="@/assets/img/img-cs.png" alt="" />
				</div>
				<div class="info">
					<p>이지스헬스케어는 언제나 고객님들의 목소리에 귀를 기울이고 있습니다.</p>
					<p>이지스펜차트를 사용하시면서 불편했던 점이나</p>
					<p>서비스 개선을 바라시는 부분이 있다면 문의를 남겨주세요.</p>
					<p>문의해주신 내용은 담당자가 신속하게 확인 후 회신 드리도록 하겠습니다.</p>
				</div>
				<div class="table">
					<table>
						<tr>
							<td>병원명</td>
							<td>{{ this.$store.state.storeHospNm }}</td>
						</tr>
						<tr>
							<td>발신인</td>
							<td>{{ this.$store.state.storeDoctNm }} 원장님</td>
						</tr>
						<tr>
							<td>문의종류</td>
							<td>
								<div class="question-type">
									<select v-model="selectReqType" title="문의">
										<option value="">문의 유형</option>
										<option v-for="(option, index) in optionReqType" :key="index" v-bind:value="option.cmCd">
											{{ option.cmNm }}
										</option>
									</select>
								</div>
							</td>
						</tr>
						<tr>
							<td>e-mail</td>
							<td>
								<input type="email" v-model="email" placeholder="이메일을 입력해주세요." />
							</td>
						</tr>
						<tr>
							<td class="v-align-top">문의내용</td>

							<td>
								<textarea v-model="message" placeholder="문의내용을 입력해주세요. (최대 1000자)" maxlength="1000"></textarea>
							</td>
						</tr>
					</table>
				</div>
				<section class="blank"></section>
				<section class="send" id="send" @click="popupSend()"><i></i><span>전송하기</span></section>
			</section>

			<!-- 전송 알림 모달-->
			<section class="common-wrap">
				<a class="common_open"></a>
			</section>
			<section class="common-modal" id="common">
				<div class="alert">전송 하시겠습니까?</div>
				<div class="btn-group">
					<a class="btn-cancel common_close">취소</a>
					<a class="btn-common" @click="send()">전송</a>
				</div>
			</section>

			<!-- 전송 확인 알림 모달 -->
			<section class="common2-wrap">
				<a class="common2_open"></a>
			</section>

			<section class="common2-modal" id="common2">
				<div class="alert">전송 완료 되었습니다</div>
				<div class="btn-group">
					<a class="btn-common2 common2_close" @click="pageBefore()">확인</a>
				</div>
			</section>

			<!-- validation 체크 모달 -->
			<section class="common3-wrap">
				<a class="common3_open"></a>
			</section>

			<section class="common3-modal" id="common3">
				<div class="alert" id="common3Text"></div>
				<div class="btn-group">
					<a class="btn-common3 common3_close">확인</a>
				</div>
			</section>

			<JqueryPopup />
		</div>
		<div v-show="renderFlag === 'N'"><loading-component></loading-component></div>
	</div>
</template>
<script src="https://ajax.googleapis.com/ajax/libs/jquery/3.2.1/jquery.min.js"></script>
<script src="https://code.jquery.com/ui/1.12.1/jquery-ui.js"></script>
<script>
import JqueryPopup from '@/components/jquery/JqueryPopup.vue';
import axios from 'axios';
import Loading from '../../components/loading/Loading.vue';
export default {
	components: {
		JqueryPopup,
		'loading-component': Loading
	},
	data() {
		return {
			selectReqType: '',
			optionReqType: [{}],
			email: '',
			message: '',
			renderFlag: 'N'
		};
	},
	async created() {
		await axios
			.get('https://tab.eghishc.co.kr/ws/api/common/codes/01')
			.then(res => {
				this.optionReqType = res.data.data;
				console.log(this.optionReqType);
			})
			.catch(e => {
				console.log(e);
			});
		this.renderFlag = 'Y';
	},
	mounted() {
		if ($('#common_wrapper').length > 0) $('#common_wrapper').remove();
		if ($('#common2_wrapper').length > 0) $('#common2_wrapper').remove();
		if ($('#common3_wrapper').length > 0) $('#common3_wrapper').remove();

		$('#common').popup({
			transition: 'all 0.3s',
			blur: true,
			escape: true,
			scrolllock: true,
			closebutton: false,
			background: true,
			onclose: function () {
				document.body.style.overflow = 'visible';
			}
		});

		$('#common2').popup({
			transition: 'all 0.3s',
			blur: true,
			escape: true,
			scrolllock: true,
			closebutton: false,
			background: true,
			onclose: function () {
				document.body.style.overflow = 'visible';
			}
		});

		$('#common3').popup({
			transition: 'all 0.3s',
			blur: true,
			escape: true,
			scrolllock: true,
			closebutton: false,
			background: true,
			onclose: function () {
				document.body.style.overflow = 'visible';
			}
		});
	},
	watch: {
		selectReqType() {
			this.validationCheck();
		},
		email() {
			this.validationCheck();
		},
		message() {
			this.validationCheck();
		}
	},
	methods: {
		validationCheck() {
			const el = document.querySelector('#send');
			if (this.selectReqType.trim() != '' && this.email.trim() != '' && this.message.trim() != '') {
				el.classList.add('active');
			} else {
				el.classList.remove('active');
			}
		},
		popupSend() {
			if (this.selectReqType === '') {
				$('#common3Text').text('문의 유형을 선택해주세요.');
				$('.common3_open').click();
				return;
			}

			if (this.email === '') {
				$('#common3Text').text('e-mail을 입력 해주세요.');
				$('.common3_open').click();
				return;
			}

			if (this.message === '') {
				$('#common3Text').text('문의 내용을 입력 해주세요.');
				$('.common3_open').click();
				return;
			}
			$('.common_open').click();
		},
		//저장
		async send() {
			$('.btn-cancel').click();
			var data = JSON.stringify({
				hospCd: this.$store.state.storeHospNo,
				category: this.selectReqType,
				userId: this.$store.state.storeUserId,
				email: this.email,
				message: this.message,
				regIp: this.$store.state.deviceInfo.ip,
				regDeviceId: this.$store.state.deviceInfo.deviceId
			});

			var config = {
				method: 'post',
				url: `https://tab.eghishc.co.kr/ws/api/msg/request/customer`,
				headers: {
					'Content-Type': 'application/json'
				},
				data: data
			};

			await axios(config)
				.then(function (response) {
					//  alert("저장 완료");
					if (response.data.errorCode != 0) {
						alert('저장 실패');
					} else {
						$('.common2_open').click();
					}
				})
				.catch(function (error) {
					alert(error);
					console.log(error);
				});
		},
		pageBefore() {
			this.$router
				.push({
					name: '대기리스트',
					params: {
						selectDept: this.$route.params.selectDept,
						searchKeyword: this.$route.params.searchKeyword,
						selectYYYY: this.$route.params.selectYYYY,
						selectDate: this.$route.params.selectDate,
						activeTab: this.$route.params.activeTab
					}
				})
				.catch(e => {
					console.log(e);
				});
		}
	}
};
</script>

<style scoped src="../../assets/css/page/customerRequest.css"></style>
